<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="13.5" viewBox="0 0 13.5 13.5">
    <g id="ic-layout-sections" transform="translate(0.951 0.951)">
      <rect
        id="Rectangle_78"
        data-name="Rectangle 78"
        width="12"
        height="12"
        rx="2"
        transform="translate(-0.201 -0.201)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_284"
        data-name="Line 284"
        x2="12"
        transform="translate(-0.201 2.799)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_285"
        data-name="Line 285"
        x2="12"
        transform="translate(-0.201 5.799)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_286"
        data-name="Line 286"
        x2="12"
        transform="translate(-0.201 8.799)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_914"
        data-name="Line 914"
        y2="12"
        transform="translate(3.799 -0.201)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
    </g>
  </svg>
</template>
